import React from 'react';
import { Image as ImageComponent } from '@janiscommerce/ui-web';

const Image = props => <ImageComponent {...props} />;

export default Image;
